export default {
  trends: {
    filters: {
      title: "Filtri",
      trends: "Trend",
      allTrends: "Tutti i trend",
      displayGames: "Mostra partite",
      alternateLines: "Linee alternative",
    },
    list: {
      empty: {
        noPropsAvailable: "Nessuna prop disponibile",
        noTrendsAvailableYet: "Nessun trend ancora disponibile",
        needsThreeGamesMinimum: "Servono almeno 3 partite",
        pendingOddsCheckBack: "Quote in attesa. Riprova più tardi.",
      },
      preview: {
        comboTrendPreview: "Anteprima trend combo",
        tryLinematePlus: "Prova Linemate+",
      },
      actions: {
        addAllLegsToMyPicks: "Aggiungi tutte le leg a Le mie scelte",
      },
    },
    cheatsheet: {
      title: "Scheda rapida",
      separator: {
        noLongerHundredPercent: "SOTTO NON È PIÙ 100%",
      },
    },
    details: {
      labels: {
        trendsInThisParlay: "Trend in questo parlay",
        straights: "Singole",
        all: "Tutti",
        hitRates: "Tassi di successo",
        perGame: "Per partita",
        against: "contro",
        rank: "Ranking",
        pitcher: "Lanciatore",
        handedness: "Mano dominante",
        defensiveRanking: "Ranking difensivo",
      },
      actions: {
        addAllPicksAsParlay: "Aggiungi tutte le scelte come parlay",
        removeAll: "Rimuovi tutto",
      },
    },
  },
};
